//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "messaging/messenger",
  "backbone",
  "./siteMapsView",
  "./siteMapsModel",
  "./siteMapList/siteMapListModule",
  "./siteMap/siteMapModule",
], function (
  Marionette,
  Messenger,
  Backbone,
  SiteMapsView,
  SiteMapsModel,
  SiteMapListModule,
  SiteMapModule,
) {
  "use strict";

  var SiteMapsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "siteMaps";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      var _this = this;
      var activeKb = Messenger.reqres.request("active:kb");
      Backbone.history.navigate(activeKb + "/authoringAdmin/siteMaps");
      _this.siteMaps = new SiteMapsModel.siteMaps({
        kbId: activeKb,
      });
      Messenger.onSave(function () {
        _this.siteMaps.saveCollection();
      });
      _this.layout = new SiteMapsView.siteMapsView({ model: _this.siteMaps });
      _this.list = _this.addSubModule(
        new SiteMapListModule({
          region: _this.layout.siteMapList,
        }),
      );
      _this.item = _this.addSubModule(
        new SiteMapModule({
          region: _this.layout.siteMapItem,
        }),
      );

      _this.layout.on("add:siteMap", function () {
        Messenger.save(function (success) {
          if (success) {
            var siteMap = _this.siteMaps.addItem();
            _this.list.selectItem(siteMap);
          }
        });
      });

      Messenger.vent.on(
        "delete:siteMap",
        function (model) {
          model.deleteModel();
        },
        this,
      );

      _this.siteMaps.onSynced(function () {
        _this.layout.on("show", function () {
          _this.list.show(_this.siteMaps);
        });
        _this.showRegion(_this.layout);
      });
    },
    _setUpVents: function () {
      //Show the categories admin screen
      Messenger.vent.on("show:authoring:admin:siteMaps", this.show, this);
      //show the module
      Messenger.vent.on("show:kb:admin:siteMaps", this.show, this);
    },
  });

  return SiteMapsController;
});
